export default {
    PreoccupationManagement: {
        Doc: 'Order No.',
        Channel: 'Channel',
        Store: 'Store',
        Pre: 'Preemptive status',
        Three: '3rd Party Order Time',
        Start: 'Start date',
        End: 'End date',
        Internal: 'ERP Order Time',
        form: {
            Third: 'Customer Order No.',
            Internal: 'CSG Order No.',
            code: 'Preemptive code',
            status: 'Preemptive status',
            category: 'Number of product categories',
            number: 'Total number of product lines',
            reserved: 'Pending preemptive',
            succeeded: 'Preemptive success',
            failed: 'Preemptive failure',
            store: 'Store',
            channel: 'Sales Channel',
            Three: '3rd Party Order Time',
            order: 'ERP Order Time',
            time: 'Estimated delivery time',
            Operation: 'Action',
        },
        view: {
          information: 'Account Information',
          reserve: 'Re-reserve',
          preemptTitle: 'Reserve product information',
          confirmText: 'Re-reserve this order'
        }
    }
};
